// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/aerodrome-station-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/aerodrome-station-types/aerodrome-station-types.js';

mount([g0]);
